import qs from 'qs';
import { createApi } from '@reduxjs/toolkit/query/react';
import { isomorphicWebApiBaseQuery } from 'tradera/state/services/utils/webapi-base-query';
import type {
    BookedShipmentGetByCheckoutIdRequest,
    BookedShipmentGetByPurchaseOrderIdRequest,
    GetBookedShipmentByPurchaseOrderIdApiResponse,
    GetBookedShipmentByShipmentCheckoutIdApiResponse,
} from 'tradera/state/services/types/webapi-mytradera-generated';

export const bookedShipmentsApi = createApi({
    reducerPath: 'bookedShipmentsApi',
    baseQuery: isomorphicWebApiBaseQuery,
    endpoints: (builder) => ({
        getShipmentBookingByPurchaseOrderId: builder.query<
            GetBookedShipmentByPurchaseOrderIdApiResponse,
            BookedShipmentGetByPurchaseOrderIdRequest
        >({
            query: ({ purchaseOrderId }) => {
                return `/api/webapi/mytradera/shipping/bookedShipment/getByPurchaseOrderId?${qs.stringify(
                    { purchaseOrderId },
                )}`;
            },
        }),
        getShipmentBookingByShippingCheckoutId: builder.query<
            GetBookedShipmentByShipmentCheckoutIdApiResponse,
            BookedShipmentGetByCheckoutIdRequest
        >({
            query: ({ shipmentCheckoutId }) => {
                return `/api/webapi/mytradera/shipping/bookedShipment/getByCheckoutId?${qs.stringify(
                    { shipmentCheckoutId },
                )}`;
            },
        }),
    }),
});

export const {
    useGetShipmentBookingByPurchaseOrderIdQuery,
    useGetShipmentBookingByShippingCheckoutIdQuery,
} = bookedShipmentsApi;
